<p-dialog
    header="Edit Your Online Store"
    [(visible)]="showMobileEditorDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '420px' }"
    [breakpoints]="{ '960px': '90vw', '640px': '95vw' }"
>
    <p>For the best editing experience, please open your online store on a laptop or desktop.</p>
    <ng-template pTemplate="footer">
        <button
            pButton
            type="button"
            label="Ok"
            (click)="showMobileEditorDialog = false"
        ></button>
    </ng-template>
</p-dialog>

<p-dialog
    header="Online Store Setup"
    [(visible)]="showEditStorePopup"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    [style]="{ width: '760px', maxWidth: '96vw' }"
    [breakpoints]="{ '1200px': '84vw', '960px': '90vw', '640px': '95vw' }"
>
    <div class="edit-store-popup-card">
        <div class="edit-store-popup-body">
            <p class="edit-store-popup-kicker">As a new valued customer,</p>
            <h3 class="edit-store-popup-title">Let us set up your Online Store for Free</h3>
            <p class="edit-store-popup-text">
                As a welcome gift for new customers, our team will set up an online store for you at no cost.
            </p>
            <ul class="edit-store-popup-points">
                <li>Saves you time</li>
                <li>Set up is 100% Free</li>
                <li>Customer-Focused Design</li>
            </ul>
            <div class="edit-store-popup-image-wrap">
                <img src="assets/images/POPUP image 1.webp" alt="Online store setup preview devices" />
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button
            pButton
            type="button"
            label="I'll do it myself"
            class="p-button-text"
            [disabled]="isEditStorePopupActionInProgress"
            [loading]="isEditStorePopupActionInProgress && editStorePopupActiveAction === 'self'"
            (click)="onEditStorePopupDoItMyself()"
        ></button>
        <button
            pButton
            type="button"
            label="Submit Store Details"
            [disabled]="isEditStorePopupActionInProgress"
            [loading]="isEditStorePopupActionInProgress && editStorePopupActiveAction === 'submit'"
            (click)="onEditStorePopupSubmitStoreDetails()"
        ></button>
    </ng-template>
</p-dialog>

<div class="main p-3 md:p-5">
    <span class="block text-2xl md:text-3xl font-semibold mb-2"> Your Online Store </span>
    <div class="pt-2 pb-4 tc description-text">
       {{ overviewDescription }}
    </div>
    <div class="content-wrapper flex flex-column md:flex-row justify-content-between gap-3 md:gap-0">
        <div class="flex flex-column flex-grow-1">
            <div class="text-xl md:text-2xl font-medium py-3" *ngIf="!isStoreActionsLoading; else storeActionsSkeleton">
                {{ _global?.userInfo?.businessSetup[0]?.businessDisplayName }}
            </div>
            <div class="buttons-container flex flex-column md:flex-row align-items-center gap-2" *ngIf="!isStoreActionsLoading">
                <div class="orange-site-button btn-orange btn w-full md:w-auto" *ngIf="checkIsURL(); else storeUrlNotSet" (click)="goToSite()">
                    <span class="text-center">
                        {{ getUrl(getResolvedWebStoreHost()) }}
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="white" viewBox="0 0 24 24" class="ml-2">
                            <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42L17.59 5H14V3zm7 18H3V5h7V3H3c-1.11 0-2 .89-2 2v16c0 1.1.89 2 2 2h18c1.1 0 2-.9 2-2v-7h-2v7z"/>
                        </svg>
                    </span>
                </div>
                <ng-template #storeUrlNotSet>
                    <div class="btn btn-orange w-full md:w-auto" *ngIf="sellsOnline" (click)="goToBusinessSetup()">
                        <span class="text-center">Set up your domain &amp; template</span>
                    </div>
                </ng-template>
                <div class="w-full md:w-auto" *ngIf="shouldShowEditStoreButton">
                    <span
                        class="edit-site-button cursor-pointer btn btn-blue w-full md:w-auto justify-content-center md:justify-content-start"
                        [class.disabled]="isStoreEditorLoading"
                        (click)="!isStoreEditorLoading && goToEditer()"
                    >
                        <ng-container *ngIf="isStoreEditorLoading">
                            <span>{{ isStoreEditorReconnecting ? 'Reconnecting...' : 'Opening editor...' }}</span>
                            <i class="pi pi-spin pi-spinner ml-2"></i>
                        </ng-container>
                        <ng-container *ngIf="!isStoreEditorLoading && isStoreEditorTabOpen">
                            <span>Return to Editor</span>
                            <i class="pi pi-external-link ml-2"></i>
                        </ng-container>
                        <ng-container *ngIf="!isStoreEditorLoading && !isStoreEditorTabOpen">
                            <span>Edit your online store</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="white" viewBox="0 0 24 24" class="ml-2">
                                <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42L17.59 5H14V3zm7 18H3V5h7V3H3c-1.11 0-2 .89-2 2v16c0 1.1.89 2 2 2h18c1.1 0 2-.9 2-2v-7h-2v7z"/>
                            </svg>
                        </ng-container>
                    </span>
                </div>
            </div>

            <div class="py-3 tc description-text">
               Preview your online store to see exactly what your customers see. Update your store anytime to keep its look and content fresh and up to date.
            </div>
        </div>
    </div>
</div>

<ng-template #storeActionsSkeleton>
    <div class="store-actions-skeleton">
        <div class="store-skeleton-line store-skeleton-title"></div>
        <div class="store-skeleton-button-row">
            <div class="store-skeleton-line store-skeleton-button"></div>
            <div class="store-skeleton-line store-skeleton-button"></div>
        </div>
    </div>
</ng-template>
